const formats = new Map();

export const register = (formatFunction, name = formatFunction.name) => {
	formats.set(name, formatFunction);
};

const parseJson = v => {
	try {
		return JSON.parse(v);
	} catch (e) {
		return v;
	}
};

const parseFormat = formatString => {
	const res = /([a-z]+)(?:\(([^()]+)\))?/i.exec(formatString) || [];
	return [res[1], res[2] ? res[2].split(/\s*,\s*/).map(parseJson) : []];
};

export const format = (value, formatString, lang) => {
	const [formatName, args] = parseFormat(formatString);
	if (!formatName) return value;

	const formatter = formats.get(formatName);
	return typeof formatter === "function" ? formatter(value, lang, ...args) : value;
};
